import React from 'react';
import PageLayout from '@/components/layout/PageLayout';
import CommunitiesListPage from '@/pages/CommunitiesListPage';

const CommunitiesListPageWithLayout: React.FC = () => {
  return (
    <PageLayout showComposer={false} hidePostButtons={true} pageTitle="Communities">
      <CommunitiesListPage />
    </PageLayout>
  );
};

export default CommunitiesListPageWithLayout;
